{
  "Danish": "Danska",
  "English": "Engelska",
  "Estonian": "Estländska",
  "Finnish": "Finska",
  "German": "Tyska",
  "Latvian": "Lettiska",
  "Lithuanian": "Litauiska",
  "Norwegian": "Norska",
  "Russian": "Ryska",
  "Swedish": "Svenska",
  "Ukrainian": "Ukrainska"
}
